import React from 'react';
import ReactDOM from 'react-dom';
import './index.scss';
import App from './App';

import "normalize.css/normalize.css";
import "@blueprintjs/core/lib/css/blueprint.css";
import "@blueprintjs/icons/lib/css/blueprint-icons.css";

ReactDOM.render(<App />, document.getElementById('root'));
